module.exports = __webpack_public_path__ + "static/media/about-3.45b5f9f4.svg";